export const getDateYear = dateString => {
  return new Date(dateString).getFullYear();
};
